import { GETTER_DEVICE_ID } from "./../../../store/constants/types";
import localStorageHelper from "@/localstorage/localstorage";
import { isEmpty } from "@/utils/lodash";
import { sign } from "@/api/http/utils/apiEncrypt";
import store from "@/store/index";
import * as types from "@/store/constants/types";
/**
 * default UUID from localstorage OR create
 */
let UUID: string = "";
export function creatUUid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
    .replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
    .toUpperCase();
}
export function getUUid() {
  if (UUID !== "") {
    return UUID;
  } else {
    if (localStorageHelper.has(localStorageHelper.key.UUID)) {
      UUID = localStorageHelper.get(localStorageHelper.key.UUID);
      return UUID;
    } else {
      UUID = creatUUid();
      return UUID;
    }
  }
}

export const urlFilterBaseUrlandPath: (URL: string) => any = (URL: string) => {
  try {
    const leftURL: string = URL.split("://")[1];
    const findIndex: number = leftURL.indexOf("/");
    if (findIndex > -1) {
      return {
        baseUrl: URL.substring(0, findIndex),
        path: leftURL.substring(findIndex)
      };
    } else {
      return {
        baseUrl: URL,
        path: ""
      };
    }
  } catch (error) {}
};

export const stransformDataToString: (data: any) => any = (data: any) => {
  try {
    if (data) {
      console.log('data', data);
      const pairs: any = [];
      for (const key of Object.keys(data)) {
        pairs.push(`${key}=${data[key]}`);
      }

      pairs.sort();

      const str = pairs.join("&");

      return str;
    } else {
      return "";
    }
  } catch (error) {
    return "";
  }
};

export const qsStringify: any = (obj: any, prefix?: any) => {
  const pairs = [];
  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }

    const value = obj[key];
    const enkey = encodeURIComponent(key);
    let pair;
    if (typeof value === "object") {
      pair = qsStringify(value, prefix ? prefix + "[" + enkey + "]" : enkey);
    } else {
      pair =
        (prefix ? prefix + "[" + enkey + "]" : enkey) +
        "=" +
        encodeURIComponent(value);
    }
    pairs.push(pair);
  }
  return pairs.join("&");
};

export const signBody = (info: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log("signBody结果：", sign(info));
      resolve(sign(info));
    } catch (error) {
      // console.log("signBody失败：", error);
      reject(error);
    }
  });
};

export function queryStringForGet(originUrl: any, params: any) {
  const paramsArray: any = [];
  Object.keys(params)
    .filter(key => !isEmpty(params[key]))
    .forEach(key => {
      paramsArray.push(`${key}=${params[key]}`);
    });
  let output = originUrl;
  if (paramsArray.length > 0) {
    if (output.search(/\?/) === -1) {
      output += `?${paramsArray.join("&")}`;
    } else {
      output += `&${paramsArray.join("&")}`;
    }
  }
  return output;
}

/**
 * Cookie format
 * @param cookie
 */
export function formatCookie(cookie: any) {
  if (cookie === null) {
    return null;
  } else {
    //cookie的拼接
    const paramsArray: any = [];
    Object.keys(cookie).forEach(key => {
      if (cookie[key]) {
        paramsArray.push(key + "=" + cookie[key]);
      }
    });
    return paramsArray.join(";") + ";";
  }
}

export function getQueryString(name: string, url: string) {
  if (url.indexOf(name) > -1) {
    const splitArr = url.split(";");
    for (const i in splitArr) {
      if (splitArr[i].indexOf(name) > -1) {
        return splitArr[i].split("=")[1];
      }
    }
  } else {
    return null;
  }
}

export const defaultTransactionId = () =>
  `${store.getters[types.GETTER_MASTER_ID] ||
    store.getters[types.GETTER_DEVICE_ID]}${new Date().getTime()}`;
